var isMobile = new Object();
isMobile.Android = function () {
	return navigator.userAgent.match(/Android/i);
};

isMobile.BlackBerry = function () {
	return navigator.userAgent.match(/BlackBerry/i);
};
isMobile.iOS = function () {
	return navigator.userAgent.match(/iPhone|iPad|iPod/i);
};

isMobile.iPad = function () {
	return navigator.userAgent.match(/iPad/i);
};
isMobile.Opera = function () {
	return navigator.userAgent.match(/Opera Mini/i);
};
isMobile.Windows = function () {
	return navigator.userAgent.match(/IEMobile/i);
};

isMobile.Firefox = function () {
	return navigator.userAgent.match(/Firefox/gi);
};
isMobile.InternetExplorer = function () {
	return navigator.userAgent.match(/MSIE/gi);
};
isMobile.Opera = function () {
	return navigator.userAgent.match(/Opera/gi);
};
isMobile.Safari = function () {
	return navigator.userAgent.match(/Safari/gi);
};
isMobile.any = function () {
	return (
		isMobile.Android() ||
		isMobile.BlackBerry() ||
		isMobile.iOS() ||
		isMobile.Opera() ||
		isMobile.Windows()
	);
};
if (isMobile.any() && isMobile.iPad() == null) {
	//return;
}

var ua = window.navigator.userAgent;
var is_ie = /MSIE|Trident/.test(ua);

/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

var winWT = $(window).innerWidth();
var winHT = $(window).innerHeight();

var disableScrolling = function () {
	var x = window.scrollX;
	var y = window.scrollY;
	window.onscroll = function () { window.scrollTo(x, y); };
}
var enableScrolling = function () {
	window.onscroll = function () { };
}
window.onbeforeunload = function () {
	//window.scrollTo(0, 0);
}

$(window).on('load', function () {
	//window.scrollTo(0, 0);
});
gsap.registerPlugin(ScrollTrigger);

function setupElasticMenu() {
   var elasticX = 200;
   var boxWidth = 420;
   var svgBackground = '#00000054';
   //----------------------------------------------------------------
   var svgWidth;
   var svgSquare = $('.svg-square');
   var svgPath = $('.svg-square .square-path');
   var winHeight = 0;
   var elasticObj = { x: 0 };
   var boxObj = { width: 0 };
   function drawSVGPath(elX, boxWidth) {
      // Right side Vertical line
      var pathArr = ['M' + svgWidth, 0];
      pathArr.push('L' + svgWidth, winHeight);

      // Bottom Horizontal line
      pathArr.push('L' + (svgWidth - boxWidth), winHeight);

      // Left Vertical line
      pathArr.push('Q ' + ((svgWidth - boxWidth) + elX), winHeight / 2, (svgWidth - boxWidth), 0);

      // Top Horizontal line
      pathArr.push('L' + (svgWidth), 0);
      //
      //
      svgPath.attr('d', pathArr.join(' '));
      //svgPath.attr('d', pathStr);
   }
   //----------------------------------------------------------------
   // On Resize Window
   function onSVGResize() {
	  boxWidth = $('.drawer_menu').innerWidth();
      svgWidth = $(window).outerWidth();;
      winHeight = $(window).innerHeight();
      svgSquare.attr('width', svgWidth);
      svgSquare.attr('height', winHeight);
		boxObj.width = 0;
      drawSVGPath(elasticObj.x, boxObj.width);
   }
   $(window).bind('resize', onSVGResize);
   onSVGResize();
   //----------------------------------------------------------------
   // Open Close Button Event
   window.menuOpenClose = function(tf) {
      var elX;
      var width;
      var background;
      if (tf) {
         elX = -elasticX;
         width = boxWidth;
         background = svgBackground;

      } else {
         elX = elasticX;
         width = 0;
         background = '00000000';
      }
      //----------------------------------------------------------------
      //----------------------------------------------------------------
      if (width < 1) {
         //console.log('Start Menu Closed');
			svgSquare.css({pointerEvents:'none'})
      } else {
         //console.log('Start Menu Open');
			svgSquare.css({pointerEvents:'auto'})
			svgSquare.css({display:'block'});
      }
      //----------------------------------------------------------------
      //----------------------------------------------------------------
      gsap.killTweensOf(svgSquare);
      gsap.to(svgSquare, 0.8, {
         background: background,
         ease: Expo.easeOut
      });
      gsap.killTweensOf(boxObj);
      gsap.to(boxObj, 0.8, {
         width: width, ease: Expo.easeOut
      });
      gsap.killTweensOf(elasticObj);
      gsap.to(elasticObj, 0.3, {
         x: elX, ease: Cubic.easeOut, onUpdate: () => {
            drawSVGPath(elasticObj.x, boxObj.width);
         }, onComplete: () => {
            gsap.to(elasticObj, 1.5, {
               x: 0, ease: "elastic.out(1, 0.3)",
               onUpdate: () => {
                  drawSVGPath(elasticObj.x, boxObj.width);
               },
               onComplete: () => {
                  //----------------------------------------------------------------
                  //----------------------------------------------------------------
                  if (boxObj.width < 1) {
                     //console.log('on Menu Closed');
							
							svgSquare.css({display:'none'});
                  } else {
                     //console.log('on Menu Open');
                  }
                  //----------------------------------------------------------------
                  //----------------------------------------------------------------
               }
            });
         }
      });
   };
}
$(document).ready(function () {
	$(".slimmenu").slimmenu({
		resizeWidth: '1023',
		collapserTitle: '',
		animSpeed: '500',
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: '&nbsp;'
	});

	function stickyNav() {
		if ($(window).scrollTop() >= 100) {
			$('header').addClass('sticky');
		}
		else {
			$('header').removeClass('sticky');
		}
	}

	function setMobileMenu() {
		var tempMenu;
		if (winWT <= 1023) {
			tempMenu = $('nav').find('.slimmenu').remove();
			$('.drawer_menu').prepend(tempMenu);
		} else {
			tempMenu = $('.drawer_menu').find('.slimmenu').remove();
			$('nav').append(tempMenu);
		}
	}
	setMobileMenu();

	function changeNavLogo() {
		if ($('header').hasClass('sticky')) {
			$('.has_sticky').css({ display: 'none' });
			$('.not_has_sticky').css({ display: 'block' });
		} else {
			$('.not_has_sticky').css({ display: 'none' });
			$('.has_sticky').css({ display: 'block' });
		}
	}
	changeNavLogo();
	var menuDrawer = $("header .drawer_menu");
	var navWT = menuDrawer.innerWidth();
	var tlOpen = gsap.timeline({ paused: true });
	var tlClose = gsap.timeline({ paused: true });
	$(menuDrawer).css({ right: -navWT + "px" });
	tlOpen.set(menuDrawer, { display: 'block' })
		.set('.drawer_menu li', { opacity: 0, y: 50 }, 'lbl_open')
		.set('.nav_close', { display: 'block', opacity: 0, scale: 0.7, rotate: -90 }, 'lbl_open')
		.to(menuDrawer, { duration: 0.2, right: 0, ease: Power1.easeInOut }, 'lbl_open')
		.to('.drawer_menu li', { duration: 0.6, opacity: 1, y: 0, stagger: 0.1 }, 'lbl_open+=0.3')
		.to('.nav_close', { duration: 0.3, opacity: 1, scale: 1, rotate: 0 }, 'lbl_open+=0.1')
	$(".nav-icon").on('click', function () {
		tlOpen.play(0);
		$('.nav_close').css({ display: 'block' });
		$('body').css({ overflow: 'hidden' });
		window.menuOpenClose(true);
	});

	$(".nav_close").on('click', function () {
		onDrawerClose();
	});

	$(".svg-square").on('click', function () {
		onDrawerClose();
	});

	tlClose.set(menuDrawer, { display: 'none' })
	
	function onDrawerClose() {
		//tlClose.play(0);
		$(menuDrawer).css({display: 'none'});
		$('.nav_close').css({ display: 'none' });
		$('body').css({ overflow: 'scroll' });
		window.menuOpenClose(false);
	}
	setupElasticMenu();


	$(window).on('resize', function () {
		winWT = $(window).innerWidth();
		navWT = menuDrawer.innerWidth();
		setMobileMenu();
		menuDrawer.animate({ right: -navWT + "px" }, 300);
		$('.nav_close').css({ display: 'none' });
		$('.brand_e').css({ display: 'none' });
		setInnerPageHeader();
		testimonialPopup();
		window.menuOpenClose(false);
	});
	$(window).on('scroll', function () {
		stickyNav();
		changeNavLogo();
		numberCounterAnim();
	});

	function setInnerPageHeader() {
		var headerHT = $('header').innerHeight();
		$('#inner_page').css({ paddingTop: headerHT + 'px' });
	}
	setInnerPageHeader();


	/**************************************/
	/*Split text */
	var rev_word;
	var splitText = $('.sl_line');
	splitText.each(function () {
		var currText = $(this).html()
		var old_html = currText.split(" ");
		var new_html = "";
		for (var i = 0; i < old_html.length; i++) {
			new_html = new_html + " <span class='text-" + i + "'>" + old_html[i] + " </span>";
			$(this).html(new_html);
		}
		/* if ($(this).attr('attr_sh') == 'sh_rev') {
			var scene1 = gsap.timeline();
			rev_word = $(this).find('span');
			var parentHld = $(this).parent().parent();
			ScrollTrigger.create({
				animation: scene1,
				trigger: parentHld,
				start: "top 60p%",
				markers: true
			});
			scene1.to(rev_word, { duration: 1, opacity: 1, y: 0, rotate: 0, ease: "power1.inOut", stagger: { amount: 0.2 } })
		} */
	});
	//gsap.set('.sl_line span', {opacity: 0, y: 70, rotate: 10 });

	/*Split text */
	/**************************************/


	// Video Popup
	$('.popup-youtube').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
		gallery: {
			enabled: true
		},
		closeOnBgClick: false,
		fixedContentPos: true,
	});

	/*****************************************************************************/
	/*****************************************************************************/

	var counted = 0;
	function numberCounterAnim() {
		$('.counter_con').each(function () {
			var oTop = $(this).offset().top - window.innerHeight;
			if (counted == 0 && $(window).scrollTop() > oTop) {
				$(this).find('.count').each(function () {
					var $this = $(this),
						countTo = $this.attr('data-count');
					$({
						countNum: $this.text()
					}).animate({
						countNum: countTo
					},
						{
							duration: 2000,
							easing: 'swing',
							step: function () {
								$this.text(Math.floor(this.countNum));
							},
							complete: function () {
								$this.text(this.countNum);
								//alert('finished');
							}
						});
				});
				counted = 0;
			} else {

			}
		});
	}

	/**********************************************************************************/
	/**********************************************************************************/

	$('.testimonials').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: false,
		infinite: false,
		speed: 400,
		margin: 10,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 10000,
				settings: "unslick"
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	/**************************************************************************************/
	/**************************************************************************************/
	$('.accordion-row').beefup({
		openSingle: true,
		/*scroll: true,
		scrollOffset: -140, */
	});

	$("form").on("change", ".file-upload-field", function () {
		var fileUploader = $(this).parent(".file-upload-wrapper");
		fileUploader.attr("data-text", $(this).val().replace(/.*(\/|\\)/, ''));
	});



	/**************************************************************************************/
	/**************************************************************************************/
	var imageThumb = $('.imgHld');
	var imageBgCover = imageThumb.find('.bg_cover');

	if (imageThumb.length > 0) {
		gsap.set(imageBgCover, { opacity: 0, height: '50%', y: 30 });
		ScrollTrigger.batch(imageBgCover, {
			interval: 1,
			batchMax: 3,   // maximum batch size (targets)
			onEnter: batch => {
				gsap.to(batch, { duration: 0.5, opacity: 1, y: 0, height: '100%', stagger: 0.15, overwrite: true })
			}
		});
	}

	/**************************************************************************************/
	/**************************************************************************************/
	testimonialPopup();
	hideSlickDots();

	// AOS On Scroll Reveal
	function initialiseAOS(){
		if ((winWT >= 800)) {
			AOS.init({
				easing: 'ease-out-in',
				duration: 1000,
				anchorPlacement: 'bottom-bottom',
				disable: function () {
					var maxWidth = 767;
					return window.innerWidth < maxWidth;
				}
			});
		} else {
			AOS.init({
				disable: function () {
					var maxWidth = 800;
					return window.innerWidth < maxWidth;
				}
			});
		};
	}
	initialiseAOS();
	$(window).bind('load', function(){
		initialiseAOS();
	})
});

window.hideSlickDots = function () {
	var slickDotHolder = $('.slick-slider');
	slickDotHolder.each(function () {
		var THIS = $(this);
		var currBulletLIsst = THIS.find('.slick-dots li');
		if (currBulletLIsst.length <= 1) {
			$(currBulletLIsst).parent().css({ display: 'none' });
		}
	});
}

window.testimonialPopup = function () {
	var testimonialsPanel = $('.tm_item').find('.tm_blurb');
	$(testimonialsPanel).each(function (index) {
		//var winWT = $(window).innerWidth();
		var currPlus = $(this).find('.plus');
		var currText = $(this).find('p');
		if (winWT <= 1023) {
			/* currPlus.on('click', function () {
				console.log('asdsad');
				$('.tm_blurb').find('p').css({ display: '-webkit-box', '-webkit-line-clamp': 4, 'overflow': 'hidden' });
				currText.css({ display: 'block', '-webkit-line-clamp': 'none', 'overflow': 'auto' });
			}) */
		} else {
			currPlus.hover(function () {
				currText.css({ display: 'block', '-webkit-line-clamp': 'none', 'overflow': 'auto' });
			}, function () {
				$('.tm_blurb').find('p').css({ display: '-webkit-box', '-webkit-line-clamp': 4, 'overflow': 'hidden' });
			});
		}

	});

	function onOrientationChange() {
        if (window.orientation == 90 || window.orientation == -90) {
            $(".rotate_msg").css("display", "block");
        } else {
            $(".rotate_msg").css("display", "none");
        }
    }
    window.addEventListener("orientationchange", onOrientationChange, false);
    if (isMobile.any()) {
        onOrientationChange();
    }
	
}

$(window).on('load', function(){
	$('#rc-anchor-alert').css({display:'none!important'});
});

